const addPropertyToObject = (object: { [key: string]: any }, property: string, defaultValue: any = ''): {[key: string]: any} => ({ ...object, [property]: defaultValue });

export default addPropertyToObject;
